<template>
  <div class="empty-block__text-block">
    <h5 class="message-title" v-html="title"></h5>
    <p class="message" v-html="description"></p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  }
};
</script>

<style lang="scss" scoped>
.empty-block {
  &__text-block {
    .message-title {
      font-size: 20px;
      font-weight: 600;
    }

    .message {
      font-size: 16px;
      font-weight: 400;
    }
  }
}
</style>

<style lang="scss" scoped>
.empty-block {
  &__text-block {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
}
.message-title {
  margin-bottom: 20px;
}

.message {
  text-align: center;
}
</style>
